import { render } from "./user.need.detail.vue?vue&type=template&id=3b6fb4aa&scoped=true"
import script from "./user.need.detail.vue?vue&type=script&lang=js"
export * from "./user.need.detail.vue?vue&type=script&lang=js"

import "./user.need.detail.vue?vue&type=style&index=0&id=3b6fb4aa&scoped=true&lang=css"

import exportComponent from "/drone/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b6fb4aa"]])

export default __exports__